import { Preset } from "@/models/Preset";

export const PresetRequest = (argPreset) => {
  let preset = argPreset.copy();

  if (!preset.id) {
    delete preset.id;
  }

  // Backend expects array of ID's
  for (let i = 0; i < preset.competencies.length; i++) {
    preset.competencies[i] = preset.competencies[i].id;
  }

  // Backend expects array of ID's
  for (let i = 0; i < preset.infos.length; i++) {
    preset.infos[i] = preset.infos[i].id;
  }

  // Backend expects array of ID's
  for (let i = 0; i < preset.questionnaires.length; i++) {
    preset.questionnaires[i] = preset.questionnaires[i].id;
  }

  // Backend expects array of ID's
  for (let i = 0; i < preset.threats.length; i++) {
    preset.threats[i] = preset.threats[i].id;
  }

  return preset;
};

export const PresetResponse = (preset) => {
  return new Preset(preset);
};

export const PresetsResponse = (presets) => {
  return presets.map((p) => PresetResponse(p));
};
